import { useInfiniteQuery } from "@tanstack/react-query";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import {
	limit,
	makeOffsetInfiniteQueryOptions,
	useResetInfiniteData,
} from "web_myplann/Api/infiniteQueryUtils";
import { getDashboardEventsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useEventsInfiniteQuery = (
	filterDatefrom?: string,
	filterDateto?: string,
	filterOnlyunsolved?: boolean,
	filterOnlysolved?: boolean,
	filterSortdesc?: boolean,
	pageSize: number = limit,
	options?: { enabled?: boolean },
) => {
	const queryKey = ActivityKeys.infiniteEvents(
		filterDatefrom,
		filterDateto,
		filterOnlyunsolved,
		filterOnlysolved,
		filterSortdesc,
		pageSize,
	);

	useResetInfiniteData(queryKey, { disableReset: options?.enabled === false });

	return useInfiniteQuery({
		queryKey,
		queryFn: (ctx) =>
			processResponseQuery(() =>
				getDashboardEventsV2(
					filterDatefrom,
					filterDateto,
					filterOnlyunsolved,
					filterOnlysolved,
					pageSize,
					ctx.pageParam,
					filterSortdesc,
				),
			)(ctx),
		enabled: options?.enabled !== false,
		...makeOffsetInfiniteQueryOptions({ pageSize }),
	});
};
